<template>
  <div class="bg_blue">
    <div class="container_wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/indexpc' }">首页</el-breadcrumb-item>

        <el-breadcrumb-item> 考级测试</el-breadcrumb-item>
      </el-breadcrumb>
      <el-alert title="温馨提示" type="warning" class="elalert">
        1.请根据自己的身份选择不同的考试类型<br />
        2.游客身份可以测试客观题，不可以测试实践题。<br />
        3.理论测试共20道选择题，16道单选题，4道多选题，得分大于等于总分的90%则通过客观题部分的测试并进入实践题测试；实践题共三道，可任选一道进行作答。<br />
      </el-alert>

      <el-steps
        :space="200"
        :active="1"
        finish-status="success"
        class="elsteps"
      >
        <el-step title="报名信息"></el-step>
        <el-step title="理论测试"></el-step>
        <el-step title="实践考试"></el-step>
        <el-step title="考级结果"></el-step>
        <el-step title="查看证书"></el-step>
      </el-steps>

      <div class="left_and_right_container">
        <div class="container_left">
          <div class="countdown_class" v-if="row.status == 1">
            <div class="countdown_title">倒计时</div>
            <van-count-down
              ref="countDown"
              @change="onTimeChange"
              @finish="onTimeFinish"
              :time="question.last_time"
              class="countdown_content"
            />
          </div>
          <div class="container_left_content">
            <div class="container_left_content_img">
              <img :src="row.user.face" />
            </div>
            <div class="container_left_content_name">
              <span>姓名：</span>{{ row.user.name }}
            </div>
            <div class="container_left_content_name">
              <span>会员号：</span>{{ row.kaoji.name }}
            </div>
            <div class="container_left_content_name">
              <span>总题数：</span>{{ row.question_list.length }}道
            </div>
            <!-- <div class="container_left_content_serve">
              <i class="el-icon-service"></i>
              <a
                :style="{ color: '#1981ff' }"
                @click="serviceCustomerClickFun()"
                >联系客服</a
              >
            </div> -->
          </div>
        </div>
        <div class="container_center" :class="targetClass">
          <div class="question_title">
            <el-tag v-if="question.option_type == 2"
              >{{ row.current_index + 1 }} 多选</el-tag
            >
            <el-tag type="success" v-else
              >{{ row.current_index + 1 }} 单选</el-tag
            >
            {{ question.title }}
          </div>
          <div class="question_optoins">
            <div
              v-for="(option, index) in question.options"
              @click="onSelect(option)"
              :key="index"
            >
              <el-button
                style="min-width: 253px !important"
                :type="option.selected == 1 ? 'primary' : ''"
                round
                :plain="option.selected == 1 ? false : true"
                >{{ option.title }}</el-button
              >
            </div>
          </div>
          <div class="submitBtn">
            <el-button type="primary" @click="onSubmit">提交</el-button>
          </div>
          <div class="font_resize_class">
            <p class="font_resize_class_tip">字体：</p>
            <template v-for="(item, index) in fontSizeArr">
              <el-button
                type="success"
                circle
                :key="index"
                v-if="item.selected"
                @click="fontResizeFun(index)"
                >{{ item.name }}</el-button
              >
              <el-button
                circle
                :key="index"
                v-else
                @click="fontResizeFun(index)"
                >{{ item.name }}</el-button
              >
            </template>
          </div>
        </div>
        <div class="container_right">
          <div class="container_right_title">答题结果</div>
          <div class="container_right_content">
            <div v-for="(item, index) in row.question_list" :key="index">
              <span :class="'status-' + item.is_right">
                <!--            答题状态 is_right  1是正确  2是错误  3未答题-->
                {{ index + 1 }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- <div>
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </div> -->
    </div>

    <el-dialog
      title="完成答题"
      :visible.sync="dialogVisible"
      v-if="row.score > 90"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="score">{{ row.score }} <em>分</em></div>
      <div>
        恭喜您以优异成绩通过理论测试，请从三道实践题中，任选一题，点击进入（也可以分别点击查看），
        内有相关教材的链接、示范视频或文档，请在20天内，通过您的刻苦学习，录制由您亲自表演的30秒以内视频，上传成功后，
        等候评委在10个工作日内的审核，最终考试结果，将在您的考级申报窗口显示，祝您成功！
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancle">返回首页</el-button>
        <el-button type="primary" @click="goApply()">考试实践考试</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="提示信息"
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      v-else
    >
      <div class="score">{{ row.score }} <em>分</em></div>
      <div style="text-align: center">很遗憾您没有通过理论测试</div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancle">返回首页</el-button>
        <el-button type="primary" @click="onRestart()">重新开始</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import NewsListItem from "@/components/listItem/NewsListItem";
import { CountDown } from "vant";

Vue.use(CountDown);

export default {
  name: "CmsDetail",
  data() {
    return {
      last_time: 300 * 1000,
      dialogVisible: false,
      row: {
        id: 0,
        current_index: 0,
        question_list: [],
        user: {},
        kaoji: {},
      },
      fontSizeArr: [
        { name: "大", selected: 0, class: "font_size_big" },
        { name: "中", selected: 1 },
        { name: "小", selected: 0, class: "font_size_mini" },
      ],
    };
  },
  components: {
    NewsListItem,
  },
  computed: {
    targetClass() {
      var target_class = "";
      this.fontSizeArr.some((item) => {
        if (item.selected) {
          target_class = item.class;
        }
      });
      return target_class;
    },
    question() {
      let that = this;
      if (that.row.question_list.length == 0) {
        return {
          id: 0,
          title: "",
          last_time: 99999 * 1000,
          options: [],
        };
      }
      let question = that.row.question_list[that.row.current_index];
      question["option_type"] =
        question.options.filter((option) => {
          return option.correct == 1;
        }).length > 1
          ? 2
          : 1; //1单选 2多选
      question.last_time = question.last_time * 1000;
      return question;
    },
  },
  mounted() {
    let that = this;
    that.row.id = this.$route.query.id || 0;
    that.row.kaoji_id = this.$route.query.kaoji_id || 0;
    this.fetch();
  },
  methods: {
    fontResizeFun(index) {
      if (this.fontSizeArr[index].selected) {
        return;
      }
      this.fontSizeArr.some((item) => {
        if (item.selected) {
          item.selected = 0;
        }
      });
      this.fontSizeArr[index].selected = 1;
    },
    fetch() {
      let that = this;
      that.$api.post(
        "/api/kaoji/examedoingdetail",
        {
          id: that.row.id,
          kaoji_id: that.row.kaoji_id,
        },
        (res) => {
          console.log("examedoingdetail");
          that.row = res.data;
          if (res.data.status == 2) {
            that.dialogVisible = true;
          } else {
            that.dialogVisible = false;
            that.$refs.countDown.reset();
          }
        },
        (res) => {
          this.$message.error(res.msg);
        }
      );
    },
    onRestart() {
      let that = this;
      that.$api.post(
        "/api/kaoji/exameRestart",
        {
          id: that.row.kaoji_id,
        },
        (res) => {
          that.fetch();
        },
        (res) => {
          this.$message.error(res.msg);
        }
      );
    },
    onSelect(record) {
      console.log("onSelect");
      if (this.question.option_type == 1) {
        this.question.options.map((item) => {
          item.selected = 2;
        });
      }
      record.selected = record.selected == 1 ? 2 : 1;
    },
    searchFun() {
      this.$message({ type: "success", message: "search" });
    },
    onCancle() {
      this.$router.push({
        path: "/",
      });
    },
    onTimeChange(val) {
      let that = this;
      console.log(val);
      console.log(that.last_time);
      if (!that.question.id) {
        return;
      }
      that.$api.post(
        "/api/kaoji/examequstiontimeupdate",
        {
          id: that.row.id,
          question_id: that.question.id,
          last_time: val.minutes * 60 + val.seconds,
        },
        (res) => {},
        (res) => {
          this.$message.error(res.msg);
        }
      );
    },
    onTimeFinish() {
      let that = this;
      this.$alert("答题已超时，请重新开始", "错误", {
        confirmButtonText: "重新开始",
        type: "error",
        callback: (action) => {
          that.onRestart();
        },
      });
    },
    goApply() {
      let that = this;
      this.$router.push({
        name: "KaojiApplyStep4",
        query: {
          id: that.row.kaoji_id,
        },
      });
    },
    onSubmit() {
      let that = this;
      if (
        that.question.options.filter((option) => {
          return option.selected == 1;
        }).length == 0
      ) {
        this.$message.error("请先选择答案");
        return;
      }
      that.$api.post(
        "/api/kaoji/examequstionsubmit",
        {
          id: that.row.id,
          question_id: that.question.id,
          options: that.question.options,
        },
        (res) => {
          that.fetch();
        },
        (res) => {
          this.$message.error(res.msg);
        }
      );
    },
  },
};
</script>
<style scoped lang="scss">
.score {
  font-size: 38px;
  color: #ff7d18;
  text-align: center;
  em {
    font-size: 16px;
    color: #333;
  }
}
.status-1 {
  background: #559f07;
  color: #fff;
}
.status-2 {
  background: #e02020;
  color: #fff;
}
.status-0 {
  background: #f4faff;
  color: #666666;
}
.bg_blue {
  width: 100%;
  background: #f4faff;
  height: 100%;
  overflow: hidden;
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
  min-height: 1235px;
}
.breadcrumb {
  margin-top: 21px;
  margin-left: 23px;
  margin: 21px 0 20px 23px;
}
.elalert {
  margin: 0 0 40px 0;
}
.elsteps {
  margin: 0 0 25px 0;
}
.left_and_right_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .container_left {
    width: 212px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    // padding: 32px 0 0 33px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    .countdown_class {
      display: flex;
      flex-direction: row;
      align-items: center;
      .countdown_title {
        width: 55px;
        font-size: 18px;

        font-weight: 400;
        color: #666666;
        line-height: 25px;
        margin-right: 8px;
        box-sizing: border-box;
        padding-bottom: 3px;
      }
      .countdown_content {
        font-size: 20px;
        font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
        font-weight: 500;
        color: #e02020;
        line-height: 28px;
      }
    }
    .container_left_content {
      // width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: center;
      margin: 88px 0 0 0;
      overflow: hidden;
      .container_left_content_img {
        width: 108px;
        height: 108px;
        border-radius: 8px;
        overflow: hidden;
        margin-bottom: 16px;
        outline: none;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .container_left_content_name {
        font-size: 14px;

        font-weight: 500;
        color: #333333;
        line-height: 20px;
        // padding-left: 65px;
        margin-bottom: 9px;
        box-sizing: border-box;
        width: 108px;
        white-space: wrap;
        span {
          color: #666666;
        }
      }
      .container_left_content_serve {
        width: 108px;
        display: flex;
        flex-direction: row;
        line-height: 17px;
        font-size: 12px;

        font-weight: 400;
        color: #0091ff;
        margin-top: 8px;
        // padding-left: 65px;
        box-sizing: border-box;
        .el-icon-service {
          margin: 0 9px 0 0;
          font-size: 17px;
        }
        &:hover {
          cursor: pointer;
          font-weight: bold;
        }
      }
    }
  }
  .container_center {
    width: 648px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    padding: 36px 0 20px 0;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    .question_title {
      font-size: 18px;

      font-weight: 400;
      color: #666666;
      margin-left: 25px;
      /deep/.el-tag {
        margin-right: 8px;
        font-size: 18px;
        font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
        font-weight: 500;
        color: #333333;
      }
    }
    .question_optoins {
      margin: 14px 0 0 112px;
      /deep/.el-button {
        min-width: 253px;
        height: 41px;
        margin-bottom: 8px;
      }
    }
    .submitBtn {
      text-align: center;
      margin-top: 132px;
      /deep/.el-button {
        width: 139px;
        height: 44px;
        border-radius: 22px;
      }
    }
    .font_resize_class {
      position: absolute;
      bottom: 50px;
      right: 50px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .font_resize_class_tip {
        font-size: 16px;
      }
    }
  }

  .container_right {
    width: 312px;
    min-height: 560px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 32px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: 24px 32px 0 32px;
    .container_right_title {
      width: 122px;
      height: 33px;
      font-size: 24px;

      font-weight: 400;
      color: #333333;
      line-height: 33px;
    }
    .container_right_content {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      div {
        display: inline-block;
        flex: 20%;
        span {
          display: inline-block;
          width: 40px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border-radius: 20px;
          margin: 16px 0 0 0;
          flex: 20px;
          &:hover {
            cursor: default;
          }
        }
      }
    }
  }
}
.font_size_big {
  .question_title {
    font-size: 25px !important;
  }
  .question_optoins {
    .el-button {
      font-size: 20px !important;
    }
  }
}
.font_size_mini {
  .question_title {
    font-size: 15px !important;
  }
  .question_optoins {
    .el-button {
      font-size: 12px !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// Exame.vue?20ca50eb